var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-card-foot-item',[_c('div',{staticClass:"card-foot-date-value"},[_c('core-date',{attrs:{"date":_vm.value,"invalid":"n/a"}})],1),_c('core-card-foot-item-label',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }